import React from 'react';

const AccountHubProfileMessages = () => {
    return (
        <div>
            AccountHubProfileMessages
        </div>
    );
};

export default AccountHubProfileMessages;